// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n'
import store from './store'
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Istanbul')
import tr from 'moment/locale/tr'
Vue.use(require('vue-moment'), {
  moment
});



import Buefy from 'buefy'
//import 'buefy/dist/buefy.css'
import './assets/custom-css/custom.css'

Vue.use(Buefy)
Vue.use(require('vue-moment'));

let locale = i18n.locale


moment.locale(locale)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js